<template>
    <div>
        <page-title>编辑站点信息</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="站点名称" prop="name">
                    <el-input v-model="form.name"/>
                </el-form-item>
                <el-form-item label="域名" prop="domain">
                    <el-input v-model="form.domain" @blur="searchSubject"/>
                </el-form-item>
                <el-form-item label="备案主体" prop="subject">
                    <el-input v-model="form.subject"></el-input>
                </el-form-item>
                <el-form-item label="服务器IP" prop="host_ip_list">
                    <el-button type="text" @click="addHostIp"><i class="el-icon-plus"></i>添加IP</el-button>
                    <div>
                        <el-form-item class="host-ip-row" v-for="(item, index) in form.host_ip_list" :key="index.key"
                                      :prop="'host_ip_list.' + index + '.ip'"
                                      :rules="[{required: true, message: '请填写服务器IP。'}, {validator: validateIp, trigger: 'blur'}]">
                            <div flex="dir:left box:last" style="width: 100%">
                                <div style="padding-right: 10px">
                                    <el-input v-model="item.ip"/>
                                </div>
                                <div>
                                    <el-button type="danger" plain @click.prevent="removeHostIp(item)">删除</el-button>
                                </div>
                            </div>
                        </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item label="授权凭证" prop="new_icon">
                    <app-upload v-model="form.certificate_url" :preview="true"></app-upload>
                </el-form-item>
                <el-form-item label="授权版本" prop="type">
                    <br>
                    <el-select v-model="form.type" placeholder="选择版本" disabled>
                        <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="子账户数量" prop="account_num"
                              :style="'display: ' + (form.type === 2 ? 'block' : 'none')">
                    <div style="color: #909090">填写<span>-1</span>表示不限制子账户数量</div>
                    <el-input v-model="form.account_num"></el-input>
                </el-form-item>
                <el-form-item label="微擎版版本" prop="we7_branch"
                              :style="'display: ' + (form.type === 1 ? 'block' : 'none')">
                    <el-radio v-model="form.we7_branch" :label="1">自运营版</el-radio>
                    <el-radio v-model="form.we7_branch" :label="2">无限开版</el-radio>
                </el-form-item>
                <el-form-item label="小程序数量" prop="app_count"
                              :style="'display: ' + (form.type === 2 ? 'block' : 'none')">
                    <div style="color: #909090">填写<span>-1</span>表示不限制小程序数量</div>
                    <el-input type="number" min="-1" step="1" v-model="form.app_count"></el-input>
                </el-form-item>
                <el-form-item label="应用数量" prop="we7_app_num"
                              :style="'display: ' + (form.type === 1 && form.we7_branch === 1? 'block' : 'none')">
                    <div style="color: #909090">填写<span>-1</span>表示不限制应用数量</div>
                    <el-input v-model="form.we7_app_num"/>
                </el-form-item>
                <el-form-item label="备注" prop="mark">
                    <el-input v-model="form.mark"/>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '添加站点'}}
                    </el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<style scoped>
    .host-ip-row {
        margin-top: 25px;
    }

    .host-ip-row:first-child {
        margin-top: 0;
    }
</style>

<script>
import axios from '@/axios'

export default {
    data() {
        const validateAccountNum = (rule, value, callback) => {
            if (this.form.type !== 2) {
                return callback()
            }
            value = parseInt(value)
            if (isNaN(value)) {
                return callback(new Error('子账户数量必须是数字。'))
            }
            if (value === null || value === '') {
                return callback(new Error('请填写子账户数量。'))
            }
            if (value < -1) {
                return callback(new Error('请填写子账户数量必须等于大于0。'))
            }
            this.form.account_num = value
            return callback()
        }
        const validateWe7AppNum = (rule, value, callback) => {
            if (this.form.type !== 1 || this.form.we7_branch !== 1) {
                return callback()
            }
            value = parseInt(value)
            if (isNaN(value)) {
                return callback(new Error('应用数量必须是数字。'))
            }
            if (value === null || value === '') {
                return callback(new Error('请填写应用数量。'))
            }
            if (value < -1) {
                return callback(new Error('应用数量必须大于等于-1。'))
            }
            this.form.we7_app_num = value
            return callback()
        }
        return {
            loading: false,
            btnLoading: false,
            detail: null,
            typeOptions: [
                {
                    value: 2,
                    label: '独立版'
                }
            ],
            rules: {
                name: [
                    {required: true, message: '请填写站点名称。'}
                ],
                protocol: [
                    {required: true, message: '请填写选择站点传输协议。'}
                ],
                domain: [
                    {required: true, message: '请填写域名。'}
                ],
                subject: [
                    {required: true, message: '请填写备案主体。'}
                ],
                host_ip_list: [
                    {required: true, message: '请填写服务器IP。'}
                ],
                type: [
                    {required: true, message: '请选择版本。'}
                ],
                account_num: [
                    {validator: validateAccountNum}
                ],
                we7_app_num: [
                    {validator: validateWe7AppNum}
                ],
                year: [
                    {required: true, message: '请选择年费。'}
                ]
            },
            form: {
                id: null,
                name: '',
                protocol: 'https://',
                domain: '',
                subject: '',
                host_ip_list: [{
                    ip: ''
                }],
                status: 0,
                type: null,
                certificate_url: '',
                account_num: 0,
                we7_branch: 1,
                app_count: 0,
                we7_app_num: 1,
                mark: '',
                is_year: 1,
                first: false,
                end_time: '',
                price: 0
            },
            yearOptions: [
                {
                    value: 1,
                    label: '免年费版'
                },
                {
                    value: 2,
                    label: '年费版'
                }
            ]
        }
    },
    created() {
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        validateIp(rule, value, callback) {
            if (!value) {
                callback()
            } else {
                const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
                if (!reg.test(value)) {
                    callback(new Error('IP格式不正确。'))
                } else {
                    callback()
                }
            }
        },
        loadData() {
            this.loading = true
            axios({
                url: 'admin/host/detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.detail = e.data.data
                    this.form.name = e.data.data.name
                    this.form.protocol = e.data.data.protocol
                    this.form.domain = e.data.data.domain
                    this.form.subject = e.data.data.subject
                    this.form.host_ip_list = e.data.data.hostIps
                    this.form.status = e.data.data.status
                    this.form.type = e.data.data.type
                    this.form.account_num = e.data.data.account_num
                    this.form.we7_branch = e.data.data.we7_branch
                    this.form.app_count = e.data.data.app_count
                    this.form.we7_app_num = e.data.data.we7_app_num
                    this.form.certificate_url = e.data.data.certificate_url
                    this.form.mark = e.data.data.mark
                    this.form.is_year = e.data.data.is_year
                    this.form.first = e.data.data.first
                    this.form.end_time = e.data.data.end_time
                    this.form.price = e.data.data.price
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        removeHostIp(item) {
            let index = this.form.host_ip_list.indexOf(item)
            if (index !== -1) {
                this.form.host_ip_list.splice(index, 1)
            }
        },
        addHostIp() {
            this.form.host_ip_list.push({
                value: '',
                key: Date.now()
            })
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: 'admin/host/update',
                        params: {
                            id: this.form.id
                        },
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.replace('/dashboard/admin/host/index')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        },
        searchSubject() {
            axios({
                url: 'admin/host/subject',
                params: {
                    domain: this.form.domain
                },
                method: 'get'
            }).then(e => {
                if (e.data.code === 0) {
                    this.form.subject = e.data.data
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        }
    }
}
</script>
